import React, { createContext, useState, useMemo, useCallback } from "react";
export const StepsContext = createContext(void 0);
export const StepsProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState("authorize");
  const [enabledSteps, enableStep] = useState(["authorize"]);
  const [availableSteps, setAvailableStep] = useState([]);
  const isDisabledStep = useCallback(
    (step) => {
      if (!enabledSteps || enabledSteps.length === 0) {
        return true;
      }
      return !enabledSteps.includes(step);
    },
    [enabledSteps]
  );
  const setEnabledStep = useCallback(
    (step) => {
      enableStep([...enabledSteps, step]);
    },
    [enabledSteps]
  );
  const contextValue = useMemo(
    () => ({
      availableSteps,
      currentStep,
      enabledSteps,
      isDisabledStep,
      setAvailableStep,
      setCurrentStep,
      setEnabledStep
    }),
    [availableSteps, currentStep, enabledSteps, isDisabledStep, setEnabledStep]
  );
  return /* @__PURE__ */ React.createElement(StepsContext.Provider, { value: contextValue }, children);
};
